import { Checkbox, Radio, styled } from '@mui/material';
import { ChangeEvent, MouseEvent } from 'react';
import { CheckboxesConfig, RowBase } from './types';

export const PrefixCheckbox = styled(Checkbox)(({ theme }) => ({
  marginLeft: theme.spacing(-1),
}));

export const PrefixRadio = styled(Radio)(({ theme }) => ({
  marginLeft: theme.spacing(-1.5),
}));

type BodyRowSelectionPrefixProps<T extends RowBase> = {
  row: T;
  rowIndex: number;
  checkboxes: CheckboxesConfig<T>;
  variant: 'checkbox' | 'radio';
};

export const BodyRowSelectionPrefix = <T extends RowBase>({
  row,
  rowIndex,
  checkboxes,
  variant,
}: BodyRowSelectionPrefixProps<T>): JSX.Element => {
  const commonProps = {
    checked: checkboxes.isCheckedRow(row, rowIndex),
    disabled: checkboxes.isDisabledRow?.(row, rowIndex),
    size: 'small' as const,
    onClick: (e: MouseEvent) => {
      e.stopPropagation();
    },
    onChange: (e: ChangeEvent) => {
      e.stopPropagation();
      checkboxes.onRowCheckedToggle(row, rowIndex);
    },
  };

  return variant === 'checkbox' ? (
    <PrefixCheckbox {...commonProps} />
  ) : (
    <PrefixRadio {...commonProps} />
  );
};

type HeaderSelectionPrefixProps = {
  allRowsChecked: boolean;
  onCheckAllToggle: (checked: boolean) => void;
};

export const HeaderSelectionPrefix = ({
  allRowsChecked,
  onCheckAllToggle,
}: HeaderSelectionPrefixProps): JSX.Element => (
  <PrefixCheckbox
    size="small"
    checked={allRowsChecked}
    onChange={(_e, checked) => {
      onCheckAllToggle(checked);
    }}
  />
);
